<template>
  <SideNav />

  <header>
    <div
      class="page-header min-vh-50 "
      style="background-image: url('assets/img/security3.jpg');"
    >
      <!--        <span class="mask bg-black opacity-5"></span>-->
    </div>
    <div class="position-relative">
      <div class="container px-md-0 position-relative"> 
        <div class="bg-gradient-dark py-4 z-index-2 border-radius-xl mt-n7 mt-sm-n9 mt-md-n10  position-relative">        
          <div class="row align-items-center">
            <img
              src="assets/img/shapes/pattern-lines.svg"
              alt="pattern-lines"
              class="position-absolute opacity-6 start-0 top-0 linebg"
              style="z-index: 10;"
            >         
     
            <div
              class="px-3 ps-md-5 px-lg-5 col-12 col-md-5 col-lg-6  order-2 order-md-1"
              style="z-index: 20;"
            >
              <div class="text-center text-md-start py-3 py-sm-5 ">
                <div class="position-relative">
                  <h3 class="mt-sm-0 mb-3 text-yellow ">
                    TronSecurity<br class="d-none d-md-block d-lg-none"> 資訊安全
                  </h3>
                  <p class="text-white mb-3">
                    ATKey.Pro<br>ATKey.Card<br>AT.Wallet
                  </p>
                  <a
                    href="javascript:;"
                    type="button"
                    class="btn bg-gradient-warning btn-lg me-3 mt-3"
                  ><i class="material-icons me-2">menu_book</i>技術支援</a>
                </div>
              </div>
            </div>
            <div
              class="col-9 col-sm-9 col-md-6 col-lg-5 col-xl-4 order-1 order-md-2 mt-n7 mt-md-0 mt-xl-n7 mx-auto"
              style="z-index: 20;"
            >
              <img
                class="w-100"
                src="assets/img/sec1.png"
                alt="macbook"
                loading="lazy"
              >
            </div>    
          </div>
        </div> 
      </div>
    </div>
  </header>

  <div class="py-5 pt-lg-6 pb-lg-6 container px-0">
    <div class="p-3 info-hoverwarning text-center mb-4 mt-md-6">
      <div class="icon icon-shape bg-gradient-warning shadow icon-shape-circle text-warning">
        <i
          class="fa fa-newspaper  opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      TronSecurity Information
    </h4>
    <div class="row align-items-center mx-0">
      <div class="mx-auto col-lg-6 order-2 order-md-1">
        <p class="text-dark lh-lg  ">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;今日的網路環境愈趨複雜，一人多機到處都能上網，日常生活的各方面向皆與數位資訊傳播息息相關，過往所保護的網路邊界已不存在，企業如今需要面臨的是如何確實保護內部閘道口（邊緣）的挑戰。
        </p>          
        <p class="text-dark lh-lg  ">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安全存取服務邊緣零信任架構(ZTA)，已經躍升為臺灣重要的國家戰略。在2021年2月，我國行政院發布的第六期「國家資通安全發展方案（110年至113年）」明確指出在2022年到2024年將以逐年導入方式，推動政府組織導入零信任架構，建立起零信任架構中決策引擎的「身分鑑別」、「設備鑑別」，以及「信任推斷」這三大核心機制。
        </p>
      </div>
      <div class="col-lg-6 order-1 order-md-2 my-5 mb-md-0 ms-auto text-center"> 
        <img
          src="assets/img/sec2.jpg"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>

    <section class="pt-5 pt-lg-7">
      <div class="container px-0">
        <div class="row align-items-center mx-0 mb-6">
          <div class="col-lg-6  order-1 order-lg-2">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-warning text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-laptop-file opacity-10 "
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    產品介紹
                  </h5>                
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3  ">
                    TronSecurity Platform 與工研院資安整合服務平台（Security Platform as a Services , SECPAAS）及AuthenTrend（歐生全）等合作伙伴進行技術轉移合作，提供您建立零信任架構（ZTA）中決策引擎「身分鑑別」的核心機制，使用者可以使用 FIDO2 Key（ATKey.Pro、ATKey.Card、AT.Wallet）、AuthFi authenticator app（download from store）、PassKey（Android 11+、iOS 15+、iCloud Keychain enabled）在您的網站服務平台下進行無密碼或多因子認證（MFA），建立一個安全不會被釣魚且易於管理的環境。
                  </li>
                </ul>
              </div>
            </div> 
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-warning text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-shield-halved opacity-10 "
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    產品特色
                  </h5>                
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3  ">
                    本產品全面採用容器化微服務架構，大型企業或公部門組織可使用 Kubernetes（K8s）快速部署組織內部專屬的服務信任方（Relying Party，RP）平台，也可彈性選擇訂閱制方案。組織內部相關部門只需自行註冊網站服務信任方（Relying Party，RP），即可獲取整合工具，快速將 FIDO2 及 MFA 等服務整合到您的網站平台上。
                  </li>
                </ul>
              </div>
            </div> 
          </div>     
          <div class="mx-auto col-lg-6 order-2 order-lg-1  mb-5 mb-lg-0">
            <img
              src="assets/img/security2-s.jpg"
              class="img-fluid rounded shadow-lg"
            >
          </div> 
        </div>
      </div>
    </section>      
    <div class="p-3 info-hoverwarning text-center mb-4 mt-md-6">
      <div class="icon icon-shape bg-gradient-warning shadow icon-shape-circle text-warning">
        <i
          class="fas fa-fingerprint  opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      FIDO2 Key
    </h4>
    <div class="row align-items-center mx-0">
      <div class="row mb-5">
        <div class="col-md-4 text-center align-items-center">
          <img
            src="assets/img/FIDO1.png"
            style="max-width: 200px;"
            class="mb-4  w-80"
          >
          <h5>AT.Wallet</h5>
        </div> 
        <div class="col-md-4 text-center">
          <img
            src="assets/img/FIDO2.png"
            style="max-width: 200px;"
            class="mb-4 w-80"
          >
          <h5>ATKey.Card</h5>  
        </div> 
        <div class="col-md-4 text-center">
          <img
            src="assets/img/FIDO3.png"
            style="max-width: 200px;"
            class="mb-4  w-80"
          >
          <h5>ATKey.Pro</h5>
        </div>          
      </div>   
      <div class="mx-auto mb-5 col-10">
        <p class="text-dark lh-lg break-all">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FIDO2 KEY 採用 AuthenTrend（歐生全）解決方案 ATKey.Pro、ATKey.Card、AT.Wallet，AuthenTrend是臺灣唯一受微軟情報安全性聯盟（Microsoft Intelligent Security Association）認可之安全金鑰廠商也是微軟官方無密碼解決方案十大合作夥伴之一，並且在2020-2021年間連續獲得Enterprise Security Magazine評選為亞太區十大多因素認證公司與指紋辨識服務提供商
        </p>          
      </div>
      <div class="mx-auto col-xl-10">
        <div class="row">
          <div class="col-md-6">
            <div class="row align-items-center justify-content-center">
              <img
                src="assets/img/FIDO4.jpg"
                style="max-width: 170px;"
              >
              <div class="col-8 mt-4">
                <h5 class="break-all">
                  AuthFi authenticator app
                </h5>
                <p class="break-all">
                  download from store
                </p>
              </div>
            </div>  
          </div>            
          <div class="col-md-6">
            <div class="row align-items-center justify-content-center">
              <img
                src="assets/img/FIDO5.jpg"
                style="max-width: 170px;"
              >
              <div class="col-8 mt-4">
                <h5 class="break-all">
                  PassKey
                </h5>
                <p class="break-all">
                  Android 11+、iOS 15+<br>iCloud Keychain enabled
                </p>
              </div>
            </div>  
          </div>  
        </div>
      </div>
    </div>
  </div>


  <div class="container">
    <img
      src="assets/img/security1.jpg"
      class="img-fluid rounded shadow-lg"
    >
  </div>


  <footer class="footer mt-5">
    <div class="container">
      <div class=" row align-items-center">
        <div class="col-md-6 mb-md-4 me-auto">
          <div class="d-none d-md-block">
            <a 
              href="javascript:;"
              @click="goToPage('/')"
            >
              <img
                src="assets/img/logo4.svg"
                class="mb-3"
                style="width: 160px;"
              >
            </a>
          </div>
        </div>

        <div class="col-md-6 mb-md-4 ms-auto text-center text-md-end">
          <a
            href="javascript:;"
            class="mb-3"
          ><img
            src="assets/img/logo4.svg"
            style="width: 160px;"
            class="mb-3 d-md-none"
          ></a>

          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="mb-1">
            新北市三重區重新路五段609巷14號5樓之3
          </p>
          <p class="mb-1">
            02-29992891
          </p>
        </div>
        <div class="col-12">
          <div class="text-center">
            <p class="text-dark my-2 my-md-4 text-sm font-weight-normal">
              Copyright ©
              2023
              by Cloud Raise Technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;
    function goToPage(page){
      router.push( { path: page } );
    }


    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
